import React, { useCallback, useEffect, useState } from 'react'
import { Modal, Pressable, StyleSheet, View } from 'react-native'
import { useEventListener } from 'expo'
import { useVideoPlayer, VideoView } from 'expo-video'

import { DS } from '../../design-system'
import { useStore } from '../../models'
import { useThrottledCallback } from 'use-debounce'

interface VideoModalProps {
  isVideoPlayerVisible: boolean
  closeVideoPlayer: () => void
  url: string
  videoProps?: Omit<React.ComponentProps<typeof VideoView>, 'player'>
}

const VideoModal = (props: VideoModalProps) => {
  const {
    session: { updateDailyTaskStatus, selectedDailyTask }
  } = useStore()
  const { isVideoPlayerVisible, closeVideoPlayer, url, videoProps } = props
  const [is80PercentCompleted, setIs80PercentCompleted] = useState(false)
  const [duration, setDuration] = useState(0)

  const player = useVideoPlayer(url, (player) => {
    player.volume = 1
    player.timeUpdateEventInterval = 1
    player.play()
  })

  useEventListener(player, 'timeUpdate', (payload) => {
    payload.currentTime
    onProgress(payload.currentTime)
  })
  useEventListener(player, 'statusChange', (payload) => {
    payload.status === 'readyToPlay' && setDuration(player.duration)
  })

  const markTaskAsCompleted = useCallback(async () => {
    try {
      console.log('updateDailyTaskStatus 1', selectedDailyTask)
      if (selectedDailyTask && selectedDailyTask.category.toLowerCase() === 'learn') {
        console.log('Video task')
        await updateDailyTaskStatus()
      }
      console.log('updateDailyTaskStatus 2')
    } catch (error) {
      console.log('Error in markTaskAsCompleted', error)
    }
  }, [selectedDailyTask, updateDailyTaskStatus])

  const onProgress = useCallback((currentTime: number) => {
    if (duration > 0) {
      const eightyPercent = duration * 0.8
      if (currentTime >= eightyPercent && !is80PercentCompleted) {
        setIs80PercentCompleted(true)
        markTaskAsCompleted()
        console.log('80% of the video is completed!')
      }
    }
  }, [])

  const closeModal = useThrottledCallback(
    () => {
      closeVideoPlayer()
      setIs80PercentCompleted(false) // Reset the state
    },
    250,
    { leading: true }
  )

  return (
    <Modal
      presentationStyle="overFullScreen"
      animationType="fade"
      transparent={true}
      visible={isVideoPlayerVisible}
      onRequestClose={closeModal}
      style={{ borderRadius: 20 }}
    >
      <View style={styles.backdrop}>
        <View style={[styles.container, containerStyles.webWrapper]}>
          <Pressable onPress={() => closeModal()} style={styles.closeContainer}>
            <DS.Frame style={styles.closeButton}>
              <DS.Icon name="Close" size={16} color="Global/Black" />
            </DS.Frame>
          </Pressable>

          <View style={styles.modalView}>
            <VideoView
              style={videoProps?.style}
              player={player}
              allowsFullscreen
              contentFit={videoProps?.contentFit || 'contain'}
              {...videoProps}
            />
          </View>

          {/* <View style={styles.modalView}>
          <Video
            source={{ uri: url }}
            rate={1.0}
            volume={1.0}
            paused={false}
            repeat={false}
            onLoad={onLoad}
            ignoreSilentSwitch="ignore"
            resizeMode={videoProps?.resizeMode ? videoProps.resizeMode : ResizeMode.CONTAIN}
            playWhenInactive={true}
            playInBackground={true}
            onProgress={onProgress}
            muted={false}
            {...videoProps}
          /> 
        </View>*/}
        </View>
      </View>
    </Modal>
  )
}

const containerStyles = StyleSheet.create({
  webWrapper: {
    width: '100%',
    maxWidth: 600,
    alignSelf: 'center'
  }
})

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  modalView: {
    maxWidth: '90%',
    maxHeight: '80%',
    aspectRatio: '9/16',
    borderRadius: 20,
    backgroundColor: '#fff',
    alignItems: 'center',
    overflow: 'hidden'
  },
  closeContainer: {
    width: '90%'
  },
  closeButton: {
    alignSelf: 'flex-end',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 10,
    marginRight: 15,
    height: 32,
    width: 32,
    borderRadius: 50,
    backgroundColor: '#DDDAD2',
    color: '#121212'
  }
})

export default VideoModal
